import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  Page: 1,
  Limit: 25,
  SearchBy: "",
  SearchValue: "",
  OrderBy: "",
  To: "",
  Sort: "ASC",
  Op: "like",
  Slug: "",
  Contract: "",
  ViewType: "Active",
};
const Reducer = createSlice({
  name: "Filer",
  initialState,
  reducers: {
    SetTableSort: (state, action) => {
      return {
        ...state,
        Sort: action.payload.Sort,
        OrderBy: action.payload.OrderBy,
      };
    },
    NavigatePage: (state, action) => {
      return {
        ...state,
        Page: action.payload,
      };
    },
    ChangeFilterLimit: (state, action) => {
      return {
        ...state,
        Page: 1,
        Limit: action.payload,
      };
    },

    ResetFilter(state, action) {
      if (action.payload) {
        return {
          ...initialState,
          ...action.payload,
        };
      }
      return initialState;
    },
    SetFilter(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});
export default Reducer.reducer;
export const {
  SetTableSort,
  NavigatePage,
  ChangeFilterLimit,
  ResetFilter,
  SetFilter,
} = Reducer.actions;
